import {
    AttributionBudgetModelDto,
    AttributionRanModelDto,
    AttributionSubventionForEnveloppeModel,
    ModeleExecAttributionBudgetDtoInput
} from 'src/graphql/generated-types';
import { AllocationsContext } from 'src/app/_shared/services/allocations/detail/allocation.service';

const stateName = '[Shared][AllocationExecution] ';

export type SharedAllocationExecutionCode =  (typeof AllocationsContext)[keyof typeof AllocationsContext];
export interface SharedAllocationExecution {
    id: number;
    articleId?: number;
    isNominatif: boolean;
    label: string;
}

export class SharedAllocationExecutionSetParamsAction {
    static readonly type = stateName + 'SetParams';

    constructor(public payload: {
        code: SharedAllocationExecutionCode,
        allocation: SharedAllocationExecution
    }) {
    }
}

export class SharedAllocationExecutionExecuteAllocationAction {
    static readonly type = stateName + 'ExecuteAllocation';

    constructor(public payload: ModeleExecAttributionBudgetDtoInput) {
    }
}

export class SharedAllocationExecutionCancelAllocationExecutionAction {
    static readonly type = stateName + 'CancelAllocationExecution';

    constructor(public payload: {code: SharedAllocationExecutionCode, allocationId: number}) {
    }
}
